const cssZipReducer = (state = '', action) => {
	switch(action.type){
	case 'CSSZIPVALUE':
		return action.payload;
	default:
		return state;
	}
}

export default cssZipReducer;